<template>
    <label class="label-field np-field" :class="{ 'error error-data': error }">
        <span class="field-name">{{ trans('general.np_branch') }} (<a href="https://novaposhta.ua/office" class="text-color-link no-underline text-sm" target="_blank">{{ trans('general.np_branchs_map') }}</a>) <span v-if="required">*</span></span>
        <input autocomplete="password" :class="{ checkelement: required }" :required="required" type="text" @input="resetObject(), getNumbers(), checkElement()" v-model="number" :placeholder="trans('general.np_branch')">
        <ul v-if="results" class="search_results">
            <li v-for="(item, index) in results" :key="index" @click="setObject(index)">
                {{ item.Description }}
            </li> 
        </ul>
        <span class="label-messages-icons">
            <svg class="message-icon error-icon">
                <use xlink:href="/img/front/icons/svgmap.svg#error"/>
            </svg>
            <svg class="message-icon warning-icon">
                <use xlink:href="/img/front/icons/svgmap.svg#warning"/>
            </svg>
            <svg class="message-icon success-icon">
                <use xlink:href="/img/front/icons/svgmap.svg#success"/>
            </svg>
        </span>
    </label>
</template>

<script>
import helper from "./../mixins/helper";

export default {
    mixins: [
        helper,
    ],
    data() {
        return {
            number: null,
            city_ref: null,
            results: null,
            error: null
        }
    },
    props: {
        data:{
            required: true
        },
        city: {
            required: true
        },
        required: {
            required: false,
            default: false
        },
        cargo: {
            required: false,
            default: false
        }
    },
    mounted() {
        this.number = this.data;
    },
    methods: {
        getNumbers() {
            if (this.city) {
                this.city_ref = this.city.Ref;
                let big = null;
				if (this.cargo) {
					big = "9a68df70-0267-42a8-bb5c-37f427e36ee4";
				}
                let data = {
                    "apiKey": "",
					"modelName": "AddressGeneral",
					"calledMethod": "getWarehouses",
					"methodProperties": {
						"TypeOfWarehouseRef": big,
						"FindByString": this.number,
						"SettlementRef": this.city_ref,
						"Language": "ru",
						"Limit": 5
					}
                };
                let myHeaders = new Headers();
                    myHeaders.append("Content-Type", "text/plain");
                    let raw = JSON.stringify(data);
                    let requestOptions = {
                        method: 'POST',
                        headers: myHeaders,
                        body: raw,
                        redirect: 'follow'
                    };
                    fetch("https://api.novaposhta.ua/v2.0/json/", requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        if (this.isset(result.data) && result.data.length > 0) {
                            this.results = result.data;
                        } else {
                            this.results = null;
                        }
                    })
                    .catch(error => console.log('error', error));
            }
        },
        setObject(index) {
            let object = this.results[index];
            this.number = object.Description;
            this.selected_object = object;
            this.$emit('update', object);
            this.checkElement();
            console.log(object);
            this.results = null;
        },
        resetObject() {
            this.selected_object = null;
            this.$emit('update', this.selected_object);
        },
        checkElement() {
            if (this.selected_object != null && this.selected_object.hasOwnProperty('Description') && this.number == this.selected_object.Description) {
                this.error = false;
            } else {
                this.error = true;
            }
        }
    }
}
</script>
